import { createContext, useContext, useState, useCallback } from "react";

const AuthContext = createContext(null);

const API_URL = process.env.REACT_APP_API_URL || "https://api-vietnam.finkraftai.com";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("vn_user")); } catch { return null; }
  });

  const login = useCallback(async (username, password) => {
    const res = await fetch(`${API_URL}/api/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });

    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.detail || "Invalid username or password.");
    }

    const data = await res.json();
    // data: { access_token, token_type, role, full_name, uuid }
    const u = {
      role: data.role,
      full_name: data.full_name,
      username,
      uuid: data.uuid,
      token: data.access_token,
    };
    localStorage.setItem("vn_user", JSON.stringify(u));
    setUser(u);
    return u;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("vn_user");
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}